import router from '../routes';

export var StepHelper = (function() {
    let self = this;
    let documentSlug = null;

    let steps = {
        1: {
            activeRoutes: [
                'documents',
                'document-not-available',
            ],
                route: 'documents',
                active: false,
                completed: false,
        },
        2: {
            activeRoutes: [
                'document-upload',
            ],
                route: 'document-upload',
                active: false,
                completed: false,
        },
        3: {
            activeRoutes: [
                'document-process',
            ],
                route: 'document-process',
                active: false,
                completed: false,
        },
        // 4: {
        //     activeRoutes: [
        //         'document-thanks'
        //     ],
        //         route: 'document-thanks',
        //         active: false,
        //         completed: false,
        // },
    }

    self.getSteps = function (noUploadStep) {
        return steps;
    };

    self.setActive = function (activeRoute) {
        var activeRouteName = activeRoute.name;
        var foundActive = false;

        if(activeRoute.params.document) {
            this.documentSlug = activeRoute.params.document;
        }

        _.each(self.getSteps(),function(item,key) {
            if((item.activeRoutes.indexOf(activeRouteName) !== -1)) {
                item.active = (item.activeRoutes.indexOf(activeRouteName) !== -1);
                foundActive = true;
            } else {
                item.active = false;
            }

            if(! foundActive) {
                item.completed = true;
            } else {
                item.completed = false;
            }
        });
        return steps;
    };

    self.getDocumentSlug = function() {
        return this.documentSlug;
    };

    self.previeusStep = function(noUploadStep = false) {
        var activeRouteName = router.currentRoute.name;
        var steps = self.getSteps();
        var previeusStep;

        _.each(steps,function(item,key) {
            if((item.activeRoutes.indexOf(activeRouteName) !== -1)) {
                // if we are at the first step return the first step

                let previeusKey = noUploadStep || key == 1 ? 1 : key - 1;
                previeusStep = steps[previeusKey];
            }
        });

        return previeusStep;

    };

    self.back = function(noUploadStep) {
        var previeusStep = self.previeusStep(noUploadStep);

        router.push({name: previeusStep.route, params: {document: this.getDocumentSlug()}});
    };
});


// WEBPACK FOOTER //
// ./src/utils/step-helper.js